import {type CliConfig} from '@sanity/cli-core'

/** @beta */
export function defineCliConfig(config: CliConfig): CliConfig {
  return config
}
